import * as React from 'react'
import { Fragment, useState, useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
// import { nanoid } from 'nanoid';
// import _ from 'lodash';
// import Backdrop from '~components/Backdrop/Backdrop'
// import ModalConfirm from '~components/Modal/ModalConfirm'
// import DrawResultAction from './DrawResultAction';
// import { useStore } from '../../../hook-store/store';
// import { styleList } from '../promptStyle';
// import { convertToBase64, resizeImageFile } from '../../../utils/image/image-utils';

// import { kuraImagePhotoUrl } from '~config/endpoints';

// import classes from './ImageStyleFusionSettings.module.css';
// import { marks } from '~utils/marks';


import StyleSample1 from '../../image/for-style-change/style-sample/sch-sample-abstract-h224.jpeg';
import StyleSample2 from '../../image/for-style-change/style-sample/sch-sample-cartoon-h224.jpeg';
import StyleSample3 from '../../image/for-style-change/style-sample/sch-sample-cleanline-h224.jpeg';
import StyleSample4 from '../../image/for-style-change/style-sample/sch-sample-lego-h224.jpeg';
import StyleSample5 from '../../image/for-style-change/style-sample/sch-sample-oil-h224.jpeg';
import StyleSample6 from '../../image/for-style-change/style-sample/sch-sample-origami-h224.jpeg';
import StyleSample7 from '../../image/for-style-change/style-sample/sch-sample-segmentation-h224.jpeg';
import StyleSample8 from '../../image/for-style-change/style-sample/sch-sample-sketch-h224.jpeg';
import StyleSample9 from '../../image/for-style-change/style-sample/sch-sample-starry-h224.jpeg';
import StyleSample10 from '../../image/for-style-change/style-sample/sch-sample-watercolor-h224.jpeg';
// import StyleSample10 from '../../image/for-style-change/style-sample/sch-sample-lego-h224.jpeg';


// const sampleImages = [
//   StyleSample1, 
//   StyleSample2,
//   StyleSample3, 
//   StyleSample4, 
// ];
const sampleImages = [
  {image: StyleSample1, name: 'abstract painting'}, 
  {image: StyleSample2, name: 'cartoon animation'}, 
  // {image: StyleSample3, name: 'clean line painting'}, 
  {image: StyleSample4, name: 'LEGO block'}, 
  {image: StyleSample5, name: 'oil painting'}, 
  {image: StyleSample6, name: 'origami'}, 
  {image: StyleSample7, name: 'color block segmentation'}, 
  {image: StyleSample8, name: 'sketch'}, 
  {image: StyleSample9, name: 'Gogh starry night painting'}, 
  {image: StyleSample10, name: 'watercolor painting'}, 

];

const StyleChangeImagePromptSample = (props) => {
  const {
    addIpaImageHandler,
    setShowStyleSamples,
    isLoading,
  } = props;

  // console.log(ipaImages)
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [t] = useTranslation('translation');


  const addSmapleHandler = async (sampleSrc) => {
    try {
      const result = await fetch(sampleSrc);
      const resData = await result.blob();

      const sampleFile = new File([resData], 'sample.jpeg', { type: 'image/jpeg'})
      // console.log(result, resData, sampleFile);

      addIpaImageHandler([sampleFile]);
      setShowStyleSamples(false);
    } catch(err) {
      console.log(err);
      throw err;
    }
  }

  let imageStyleFusionStyleSampleBody;

  imageStyleFusionStyleSampleBody = (
    <div>
      <div>{t('syleChangeOptions05', 'Select Style image from samples')}</div>
      <div>
        <ul className='doImagePromptSampleImages'>
          {sampleImages.map(sample => {
            // console.log('sample', sample)
            return (
              <li key={sample.name}>
                <div>
                  <img className='doImagePromptSampleImage'
                    // style={{height:"100px"}}
                    onClick={() => { 
                      addSmapleHandler(sample.image); 
                    }}
                    
                    src={sample.image}
                  />
                  <div>{sample.name}</div>
                </div>
              </li>
            )
          })}
        </ul>
      </div>
    </div>
  );
  
  return (
    <Fragment>
      <div>{imageStyleFusionStyleSampleBody}</div>
    </Fragment>
  );
}

export default StyleChangeImagePromptSample;
